/**
 * 缓存一个 Promise
 * @param {Function} fn 返回一个 Promise
 * @param {Object} [storage] storage
 * @returns {Function}
 */
export function cachify(fn, storage) {
  cached.storage = storage || Object.create(null);
  return cached;
  function cached(cacheKey) {
    if (cacheKey in cached.storage) return cached.storage[cacheKey];

    const r = fn(cacheKey).catch(e => {
      delete cached.storage[cacheKey];
      return Promise.reject(e);
    });
    cached.storage[cacheKey] = r;
    return r;
  }
}
